// Direct REST client for server-to-server token capture.
// Bypasses the canonical GraphQL applyPayment pipeline to allow
// dynamic routing for PlaceToPay tokens.

function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const PAYMENT_CAPTURE_URL = getEnv('REACT_APP_PAYMENT_CAPTURE_URL');

export default async function capturePaymentToken(body) {
  if (!PAYMENT_CAPTURE_URL) {
    throw new Error(
      'capturePaymentToken: REACT_APP_PAYMENT_CAPTURE_URL is not set.'
    );
  }
  const response = await fetch(PAYMENT_CAPTURE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`capturePaymentToken HTTP ${response.status}: ${text}`);
  }
  return response.json();
}